<template>
  <div>
    <span class="md-display-1">
      {{hasShipping ?
          (separateShipping ?
            'Rechnungsadresse'
          : 'Versand- & Rechnungsadresse')
        : 'Rechnungsadresse'}}
    </span>
    <dynamic-form
      ref="invoiceForm"
      :formFields="hasShipping ? invoiceForm : invoiceForm || shippingForm"
      :hideSubmit="true"
      :initialFormData="inititalShippingFormData"
      @update="updateCountry"
    />

    <template v-if="hasShipping">
      <div>
        <md-checkbox v-model="separateShipping">
          abweichende Versandadresse
        </md-checkbox>
      </div>

      <template v-if="separateShipping">
        <span class="md-display-1">Versandadresse</span>
        <dynamic-form
          ref="shippingForm"
          v-if="separateShipping"
          :formFields="invoiceForm || shippingForm"
          :hideSubmit="true"
          @update="updateCountry"
        />
      </template>
    </template>
  </div>
</template>

<script>
import DynamicForm from '@/components/DynamicForm/DynamicForm';

export default {
  props: ["hasShipping", "shippingForm", "invoiceForm", "countryField"],
  components: {
    DynamicForm
  },
  data() {
    return {
      inititalShippingFormData: undefined,
      separateShipping: false,
      selectedCountry: undefined
    }
  },
  watch: {
    separateShipping: 'updateCountry'
  },
  methods: {
    updateCountry() {
      const formData = (!this.hasShipping || !this.separateShipping) ? this.$refs.invoiceForm && this.$refs.invoiceForm.formData : this.$refs.shippingForm && this.$refs.shippingForm.formData;
      let newCountry = formData && formData[this.countryField];
      if (this.selectedCountry !== newCountry) {
        this.selectedCountry = newCountry;
        this.$emit('country-selected', newCountry);
      }
    },
    getShippingFormData() {
      if (!this.hasShipping) {
        return undefined;
      }
      return this.$refs.invoiceForm.formData;
    },
    getInvoiceFormData() {
      if (!this.hasShipping || !this.separateShipping) {
        return this.$refs.invoiceForm.formData;
      }
      return this.$refs.shippingForm.formData;
    },
    validate() {
      return this.$refs.invoiceForm.validate().then(res => {
        return res && (!this.$refs.shippingForm || this.$refs.shippingForm.validate());
      });
    }
  },
  mounted() {
    if (this.shippingForm && this.countryField) {
      const countryField = this.shippingForm.find(f => f.name === this.countryField);
      if (countryField && countryField.fieldType === 'select' && countryField.options && countryField.options.length === 1) {
        this.inititalShippingFormData = {
          [this.countryField]: countryField.options[0].value
        };
      }
    }
    this.updateCountry();
  }
};
</script>
